export default {
  'transactions.title': 'ประวัติการทำรายการ',
  'transactions.empty': 'ไม่มีข้อมูล',
  'transactions.order.no': 'หมายเลขคำสั่งซื้อ',
  'transactions.order.status': 'สถานะคำสั่งซื้อ',
  'transactions.order.purchase_date': 'วันที่สั่งซื้อ',
  'transactions.order.item': 'รายการสินค้า',
  'transactions.order.amount': 'ยอดชำระ',
  'transactions.order.payment': 'ช่องทางการชำระเงิน',
  'transactions.order.credit_card': 'บัตรเครดิต',
  'transactions.last_month': 'เดือนที่ผ่านมา',
  'transactions.purchase_complete': 'การซื้อเสร็จสมบูรณ์',
  'transactions.view_store_value_card': 'ดูบัตรมูลค่าคงเหลือ',
  'transactions.view_tickets': 'ดูตั๋วของคุณ',
  'transactions.trade_record': 'ประวัติธุรกรรม',
} as Record<string, string>;
